import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class BharathidasanUniversityDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <p><b>Bharathidasan University :</b> A University known for its heritage, was established in the year 1982 in Tiruchirapalli with a strong motto to create a brave world. MIET provides the right knowledge and easy ways to crack exams smartly.</p>
				  
                  </ScrollAnimation>
                  
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<h5 className="mb-0 mt-2">Courses Offered: </h5>
                            <p>UG Programmes:</p>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Tamil
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Literature in Tamil
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Economics
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. English
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. History 
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Public Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Political Science
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.B.A.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Com.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Com.  (Bank Management)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Mathematics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Chemistry
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Physics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Botany
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Zoology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Geography
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Computer Science
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Information Technology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.C.A.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Lib.I.Sc.(one year programme)
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							{/* <h5 className="mb-0 mt-2">Courses Offered: </h5> */}
                            <p>PG Programmes:</p>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Economics
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. English
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Tamil
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. History
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Public Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Political Science
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Human Resource Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Mathematics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Chemistry
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Physics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Botany
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Zoology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Computer  Science
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Information  Tech.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.SC. Geography
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Com.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Com. (Financial Management)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Com. (Bank Management)
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Lib.I.Sc.
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>	
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>				
				  </div>
		      </div>
			  <Sidebar courseRestriction="Bharathidasan University"/>
		    </div>
		  </div>
		</div>

        }
}

export default BharathidasanUniversityDetails